import React, { Component } from 'react';
import fetch from "cross-fetch";
import QRCode from 'qrcode.react';
import {connect} from "react-redux";
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';

import {receiveWallet, fundingInitiated} from "../Actions";
import Centered from "../Components/Centered";
import ParagraphText from "../Components/ParagraphText";
import waitForFunds from '../Helpers/waitForFunds';
import GiftAmount from "../Components/GiftAmount";
import {getUSDfromBTC} from "../Helpers/conversion";

const StyledWallet = styled.div`
  padding-top: 40px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: stretch;
  font-weight: bold;
`;

const QRCodeContainer = styled.div`
    padding: 8px;
    background: white;
    width: auto;
    display: inline-block;
`;

const Clickable = styled.span`
  cursor: pointer;
`;

const FadeIn = styled.div`
	opacity: 1;
	animation-name: fadeInOpacity;
	animation-iteration-count: 1;
	animation-timing-function: ease-in;
	animation-duration: 0.3s;

@keyframes fadeInOpacity {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}
`;

const Spinner = styled.img`
  width: 61px;
  height: 75px;
`;

const Monospace = styled.span`
  font-family: monospace;
  background-color: #274b8e;
  padding: 10px;
  font-weight: 400;
  border-radius: 2px;
`;


class Wallet extends Component {
  componentDidMount() {
    if(!(this.props.wallet && this.props.wallet.address)) {
      const walletParams = {
        senderEmail: this.props.senderEmail,
        recipientEmail: this.props.recipientEmail,
        amount: this.props.giftAmount,
        note: this.props.note,
        template: this.props.template,
        amountUSD:  getUSDfromBTC(this.props.giftAmount, this.props.rates),
      };

      const qs = Object.keys(walletParams).map(key => `${key}=${encodeURIComponent(walletParams[key])}`).join('&');
      const url = `${process.env.REACT_APP_SERVER_URI}/m/wallet/create?${qs}`;

      fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        },
      })
        .then(response => response.json())
        .then(json => setTimeout( () => this.props.dispatch(receiveWallet(json)), 1500));
    }
  }
  componentWillReceiveProps(newProps) {
    if (!this.props.wallet.address && newProps.wallet.address) {
      waitForFunds(newProps.wallet.address).then(() =>{
        toast.info('Your gift is on its way!');
        newProps.dispatch(fundingInitiated());
      });
    }
  }
  onCopy(text) {
    toast.info(`${text} copied to clipboard!`);
  }

  render() {
    const message = 'Biterica Gift';

    return (
      <StyledWallet>
        <Centered>
        {
          !this.props.wallet.address &&
          <Centered>
            <h3>
              Status: Creating gift wallet.
            </h3>
            Please wait

            <div className="spacer-40px" />
            <Spinner src="/tower.gif" />
            <div className="spacer-40px" />
            <ParagraphText>Recipient:&nbsp;
              <ParagraphText bold> {this.props.recipientEmail } </ParagraphText>
            </ParagraphText>
            <ParagraphText>Sender:&nbsp;
              <ParagraphText bold>{this.props.senderEmail } </ParagraphText>
            </ParagraphText>
            <ParagraphText>Amount:&nbsp;
              <ParagraphText bold><GiftAmount /></ParagraphText>
            </ParagraphText>
            <div className="spacer-40px" />
          </Centered>
        }
        {
          !!this.props.wallet.address && !this.props.wallet.fundingInitiated &&
          <FadeIn>
            <Centered>
              <h3>
                Status: Awaiting transaction.
              </h3>
              <span className="text-centered">Send <CopyToClipboard text={this.props.wallet.address} onCopy={() => this.onCopy(this.props.giftAmount)}>
              <CopyToClipboard text={this.props.giftAmount} onCopy={() => this.onCopy('Amount')}>
                <Clickable>
                  <Monospace>BTC {this.props.giftAmount}</Monospace>
                </Clickable>
              </CopyToClipboard>

              </CopyToClipboard> to the following address:</span>
              <div className="spacer-20px" />
              <CopyToClipboard text={this.props.wallet.address} onCopy={() => this.onCopy('BTC address')}>
                <Clickable>
                  <Monospace>{this.props.wallet.address}</Monospace>
                </Clickable>
              </CopyToClipboard>

              <h3>OR</h3>
              <Centered>
                Have a wallet app?
                <div>&nbsp;
                  <a className="underline" href={`bitcoin:${this.props.wallet.address}?amount=${this.props.giftAmount}&label=Gift&message=${encodeURIComponent(message)}`} target="_blank">Open wallet</a>
                </div>
              </Centered>
              <h3>OR</h3>
              Scan QR code:
              <div className="spacer-20px"/>
              <Centered>
                <QRCodeContainer>
                  <QRCode value={`bitcoin:${this.props.wallet.address}?amount=${this.props.giftAmount}&label=Gift&message=${encodeURIComponent(message)}`} />
                </QRCodeContainer>
              </Centered>
              <div className="spacer-40px" />

              <div className="text-centered">
                A delivery receipt will be sent to the sender's email address after funding.
              </div>
              <div className="spacer-40px" />

            </Centered>
          </FadeIn>
        }
        {
          !!this.props.wallet.address && this.props.wallet.fundingInitiated &&
          <FadeIn>
            <Centered>
              <h3>
                Status: Gift is on its way!
              </h3>
              <ParagraphText bold>The gift was delivered to&nbsp;
                <a className="underline" href={`mailto:${this.props.recipientEmail}`}>{this.props.recipientEmail }</a>
              </ParagraphText>
              <div className="spacer-20px" />

              <ParagraphText>Amount:&nbsp;
                <ParagraphText bold><GiftAmount /></ParagraphText>
              </ParagraphText>
              <div className="spacer-20px" />

              <ParagraphText>
                A confirmation will be sent to {this.props.senderEmail} shortly.
              </ParagraphText>
              <div className="spacer-20px" />

              <a className="underline" href={`https://www.blockchain.com/btc/address/${this.props.wallet.address}`} target="_blank">View Transaction</a>

            </Centered>
            <div className="spacer-40px" />

          </FadeIn>

        }
        </Centered>

      </StyledWallet>
    );
  }
}

const mapStateToProps = (state) => ({
  recipientEmail: state.gift.recipientEmail,
  senderEmail: state.gift.senderEmail,
  giftAmount: state.gift.giftAmount,
  template: state.gift.template,
  note: state.gift.note,
  wallet: state.wallet,
  rates: state.conversionRates.rates,
});

export default connect(mapStateToProps)(withRouter(Wallet));


// WEBPACK FOOTER //
// ./src/Containers/Wallet.js